import { FC } from 'react';
import Fieldset from '~/components/commonUi/Fieldset';
import { Candidate, Region } from '~/definitions/candidates';
import Column from './Column';
import Row from './Row';
import Button from '~/components/commonUi/Button/Button';
import { observer } from 'mobx-react';
import { getStore } from '~/mobx/AppStore';

interface Props {
    regions: Region[];
    selectedRegion: Region;
    candidates: Candidate[];
    isLoadingCandidateList: boolean;
    isDisabled: boolean;
}

const List: FC<Props> = observer((props) => {
    const candidateStore = getStore().candidateStore;

    const title = `${props.selectedRegion?.name} - Kandidater`;
    const cellBaseStyle = 'leading-[34px] p-2';
    const tableStyle =
        'border-t border-b border-[#bebebe] text-[#212529] mb-4 align-top w-full border-collapse text-[#212529] text-left';

    const handleCreateCandidate = () => {
        candidateStore.onCreateCandidate();
    };

    if (props.isLoadingCandidateList) {
        return null;
    }

    return (
        <Fieldset title={title}>
            <>
                <table className={tableStyle}>
                    <Column baseStyle={cellBaseStyle} />
                    <Row baseStyle={cellBaseStyle} candidates={props.candidates} />
                </table>
                {!props.isDisabled && (
                    <div className="text-right">
                        <Button btnText="Opprett kandidat" testId="create-candidate" onClick={handleCreateCandidate} />
                    </div>
                )}
            </>
        </Fieldset>
    );
});

export default List;
